import _ from 'lodash';
import fp from 'lodash/fp';
import React, { useState, useContext, useEffect } from 'react';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { withStyles } from '@mui/styles';
import { ColumnItemList } from './column-item.table';

import { TableContext } from '../context.table';

const styles = () => ({});

export const ColumnSorter = withStyles(styles)(() => {
  // @ts-expect-error TS(2339): Property 'columns' does not exist on type '{ onSor... Remove this comment to see the full error message
  const { columns, reorderColumn } = useContext(TableContext);
  const { items, onDragEnd } = useDraggable(columns, reorderColumn);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="column-order">
        {(provided: any) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            <ColumnItemList items={items} />
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
});

const keyMap = {
  name: 'id',
  label: 'content',
};

function useDraggable(initial: any, reorderColumn: any) {
  const [state, setState] = useState([]);

  // mounting, format list
  useEffect(() => {
    setState(
      initial.map((item: any) =>
        fp.flow(
          fp.pick(['name', 'label', 'show', 'canToggle']),
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          fp.mapKeys((key) => keyMap[key] || key)
        )(item)
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initial]);

  function onDragEnd(result: any) {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const items = reorder(state, result.source.index, result.destination.index);

    // @ts-expect-error TS(2345): Argument of type 'unknown[]' is not assignable to ... Remove this comment to see the full error message
    setState(items);

    if (_.isFunction(reorderColumn)) {
      reorderColumn(items);
    }
  }

  return { onDragEnd, items: state };
}

function reorder(list: any, startIndex: any, endIndex: any) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

// @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'JSX... Remove this comment to see the full error message
ColumnSorter.displayName = 'ColumnSorter';
